/* eslint-disable max-lines */
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { API_RESPONSE, AppConstants } from 'common/app-constants';
import { BaseComponent } from 'common/components/base/base.component';
import { HvacAutoCompleteEvent } from 'common/components/hvac-autocomplete/hvac-auto-complete.component';
import { Option } from 'common/components/select/select.component';
import { ToastService } from 'common/services/toast.service';
import { BrandedPricingAndWarrantyConfiguration, BrandedRelationships, CompanyRelationshipsResult, DealerDistributor, PricingBrandWarrantyRelationship, PricingWarrantyRelationships, RelationshipConfig, RelationshipTabOption } from 'private/app/models/account-admin-company.model';
import { AccountAdminBrandsItemsEntity, CompanyServices } from 'private/app/models/account-admin-search';
import { ACTIVATED_STAT, CompanyDetailsResponse } from 'private/app/models/distributor-relationships.model';
import { AccountAdminExtendedService } from 'private/app/services/account-admin/account-admin-extended.service';
import { AccountAdminService } from 'private/app/services/account-admin/account-admin.service';
import { AccountAdminCompanyCreateService } from 'private/app/services/account-admin/account-admin-company-create.service';
import { CompanyQueryService } from 'private/app/services/account-admin/company-query.service';
import { AutocompleteInputTypes, ClaimOption, CompanyRelationshipService, NON_BRANDED, RelationshipTypeCode, RelationshipTypeId } from 'private/app/services/account-admin/company-relationship.service';
import { AccountAdminDetailsEditConfiguration } from 'private/app/views/account-admin-company-details/company-query/company-query-configuration';
import { BehaviorSubject, combineLatest, EMPTY, Observable, of } from 'rxjs';
import { takeUntil, debounceTime, switchMap, catchError, tap, startWith, map } from 'rxjs/operators';
type ManageRelationshipProfiles = keyof BrandedPricingAndWarrantyConfiguration


enum RelationTypeCodeField {
    RelationTypeCode = 'relationTypeCode'

}
@Component({
    selector: 'hvac-manage-relationship',
    templateUrl: './manage-relationship.component.html',
    styleUrls: ['./manage-relationship.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ManageRelationshipComponent extends BaseComponent implements OnInit {
    @Input() onFormSubmit: Observable<void> = new Observable<void>();
    @Input() relationshipList?: PricingBrandWarrantyRelationship[];
    @Input() isCreate?: boolean;
    @Input() brandFamily: string;
    @Input() hvacCompanyId?: string;
    @Output() submitChanges = new EventEmitter<CompanyRelationshipsResult>();
    @Input() selectedRelationship: Observable<PricingBrandWarrantyRelationship> = new Observable<PricingBrandWarrantyRelationship>();

    public brandList: Option[];
    public selectedTab: ManageRelationshipProfiles = RelationshipTabOption.BRAND;
    public showRelationshipList: boolean = false;
    public tableData: PricingBrandWarrantyRelationship[] = [];
    public isFormValid: boolean = false;
    public isEditModal: boolean = false;
    public isRelationshipExists: boolean = false;
    public unsavedChangesModal: boolean = false;
    public unsavedRelationshipsModal: boolean = false;
    public tabAfterModalClose: ManageRelationshipProfiles;
    public warningMessage: string;
    public autocompleteInputType: string;
    public companyNameInputDisabled: boolean = false;
    public hvacpIdInputDisabled: boolean = false;
    public soldToInputDisabled: boolean = false;
    public noResutsFoundFlag: boolean = false;
    public validationToastErrorId: string = 'brandValidationError';
    public showTierLevel: boolean = true;

    public relationshipForm: UntypedFormGroup = new UntypedFormGroup({
        brand: new UntypedFormControl('', [Validators.required]),
        distributorCompanyName: new UntypedFormControl(''),
        distributorHvacpId: new UntypedFormControl('', [Validators.maxLength(60)]),
        distributorSoldTo: new UntypedFormControl('', [Validators.maxLength(60)]),
        cinNumber: new UntypedFormControl('', [Validators.required, Validators.maxLength(10), Validators.pattern(/^[a-zA-Z0-9!"#$%&'*+\-./\\;?@\]_`]+$/)]),
        tierLevel: new UntypedFormControl(''),
        claims: new UntypedFormControl('', [Validators.required]),
        comments: new UntypedFormControl('', [Validators.maxLength(4000)])
    })

    companyConfiguration: AccountAdminDetailsEditConfiguration;
    config = new BrandedPricingAndWarrantyConfiguration();
    selectedCompany: PricingBrandWarrantyRelationship;
    formConfig$: BehaviorSubject<RelationshipConfig> = new BehaviorSubject<RelationshipConfig>(this.config[this.selectedTab]);
    brands$: BehaviorSubject<Option[]> = new BehaviorSubject<Option[]>([]);
    companyLookUpData$: BehaviorSubject<Option[]> = new BehaviorSubject<Option[]>([]);
    companyLookUpDataHvacpId$: BehaviorSubject<Option[]> = new BehaviorSubject<Option[]>([]);
    companyLookUpDataSoldTo$: BehaviorSubject<Option[]> = new BehaviorSubject<Option[]>([]);
    companyDetails$: BehaviorSubject<CompanyDetailsResponse | null> = new BehaviorSubject<CompanyDetailsResponse | null>(null);
    companyQuerySubject$: BehaviorSubject<string> = new BehaviorSubject('');
    companyQuerySubjectHvacpId$: BehaviorSubject<string> = new BehaviorSubject('');
    companyQuerySubjectSoldTo$: BehaviorSubject<string> = new BehaviorSubject('');
    cinQuerySubject$: BehaviorSubject<string> = new BehaviorSubject('');
    invalidCIN$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    CINLengthExceeded$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    CINhasInvalidCharacters$ = new BehaviorSubject<boolean>(false);
    companyDetailsError$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    brandError$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    autoComplete$: BehaviorSubject<HvacAutoCompleteEvent> = new BehaviorSubject<HvacAutoCompleteEvent>({ loading: false });
    autoCompleteHvacId$: BehaviorSubject<HvacAutoCompleteEvent> = new BehaviorSubject<HvacAutoCompleteEvent>({ loading: false });
    autoCompleteSoldTo$: BehaviorSubject<HvacAutoCompleteEvent> = new BehaviorSubject<HvacAutoCompleteEvent>({ loading: false });

    private brandsByRelationship: ({
        code: string; id: string; name: string;
    } | undefined)[];

    private selectedBrand: string = '';
    private _companyServices: CompanyServices[] = [];

    constructor(public readonly companyRelationshipService: CompanyRelationshipService,
        protected adminService: AccountAdminService,
        protected toastService: ToastService,
        public companyQuery: CompanyQueryService,
        public accountAdminExtendedService: AccountAdminExtendedService,
        private companyCreateService: AccountAdminCompanyCreateService,
        private translate: TranslateService) {
        super();
    }

    get companyServices(): CompanyServices[] {
        return this._companyServices;
    }

    @Input() set companyServices(value: CompanyServices[] | undefined) {
        this._companyServices = value || [];
        this.updateTierLevelVisibility();
    }

    ngOnInit(): void {
        this.updateTierLevelVisibility();
        if (this.isCreate) {
            this.companyCreateService.companyCreateForm.controls.services.valueChanges.pipe(
                takeUntil(this.ngOnDestroy$)
            ).subscribe(() => this.updateTierLevelVisibility());
        }

        this.getNewBrandsList();
        this.selectedRelationship.pipe(takeUntil(this.ngOnDestroy$)).subscribe((data) => {
            if (data) {
                this.isEditModal = true;
                this.selectedCompany = data;
                const parentDetails = data?.dealerDistributor;
                const details: CompanyDetailsResponse = {
                    companyName: parentDetails?.distributorCompanyName!,
                    hvacCompanyId: parentDetails?.distributorCompanyId?.toString()!,
                    address1: parentDetails?.distributorAddress!
                };
                if (data.relationshipType === RelationshipTypeCode.WARRANTY) {
                    this.selectedTab = RelationshipTabOption.WARRANTY;
                    this.formConfig$.next(this.config[this.selectedTab]);
                    this.relationshipForm.controls.distributorCompanyName.setValue(data.dealerDistributor.distributorCompanyName);
                    this.relationshipForm.controls.comments.setValue(data.dealerDistributor.comment);
                    this.relationshipForm.controls.cinNumber.setValue(data.cin);
                    this.setClaimsEntitlementField(data.claims);
                    details.soldTo = data.soldTo?.toString();
                    this.companyDetails$.next(details);
                }

                else if (data.relationshipType === RelationshipTypeCode.PRICING) {
                    this.selectedTab = RelationshipTabOption.PRICING;
                    this.formConfig$.next(this.config[this.selectedTab]);
                    this.relationshipForm.controls.distributorCompanyName.setValue(data.dealerDistributor.distributorCompanyName);
                    this.relationshipForm.controls.comments.setValue(data.dealerDistributor.comment);
                    this.relationshipForm.controls.cinNumber.setValue(data.cin);
                    details.soldTo = data.soldTo?.toString();
                    this.companyDetails$.next(details);
                }
                else {
                    this.selectedTab = RelationshipTabOption.BRAND;
                    this.formConfig$.next(this.config[this.selectedTab]);
                    this.relationshipForm.controls.distributorCompanyName.setValue(data.dealerDistributor.distributorCompanyName);
                    this.relationshipForm.controls.comments.setValue(data.dealerDistributor.comment);
                    const selectedBrand = this.brandList.filter((brandedRelationship) => brandedRelationship?.name === data.brandName);
                    this.relationshipForm.controls.brand.setValue(selectedBrand);
                    const selectedTier = this.companyRelationshipService.tierLevelOptions.filter((tier) => tier?.value && tier.name === data.tierLevel);
                    this.relationshipForm.controls.tierLevel.setValue(selectedTier.length ? selectedTier : '');
                    this.companyDetails$.next(details);
                }
            }
        });
        this.adminService.getRelationshipTypes().subscribe((relationshipType) => {
            this.brandsByRelationship = relationshipType.map((relationship) => relationship.brand);
            this.brandList = this.brandsByRelationship.filter((relationship) => relationship && this.brandList?.some((brand) => brand.value === relationship.code)).map((brand) => ({
                name: brand?.name,
                value: brand?.id
            }) as Option);
            this.brandList.unshift({
                name: this.translate.instant('ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.SELECT_BRANDS'),
                value: ''
            });
        });

        this.companyQuery.companyDetailsConfiguration.pipe(takeUntil(this.ngOnDestroy$)).subscribe((configuration) => {
            if (NON_BRANDED.includes(configuration.companyType!)) {
                this.selectedTab = RelationshipTabOption.PRICING;
                this.formConfig$.next(this.config[this.selectedTab]);
            }
            this.companyConfiguration = configuration;
        });

        this.companyLookUpData$.pipe(takeUntil(this.ngOnDestroy$)).subscribe((_status) => {
            this.autoComplete$.next({
                loading: false,
                loadMore: this.companyRelationshipService.isLoadMoreData$.value || false
            });
            this.noResutsFoundFlag = _status.length === 0;
        });

        this.companyLookUpDataHvacpId$.pipe(takeUntil(this.ngOnDestroy$)).subscribe((_status) => {
            this.autoCompleteHvacId$.next({
                loading: false,
                loadMore: this.companyRelationshipService.isLoadMoreData$.value || false
            });
            this.noResutsFoundFlag = _status.length === 0;
        });

        this.companyLookUpDataSoldTo$.pipe(takeUntil(this.ngOnDestroy$)).subscribe((_status) => {
            this.autoCompleteSoldTo$.next({
                loading: false,
                loadMore: this.companyRelationshipService.isLoadMoreData$.value || false
            });
            this.noResutsFoundFlag = _status.length === 0;
        });

        this.relationshipForm.controls.brand.valueChanges.pipe(
            takeUntil(this.ngOnDestroy$)
        ).subscribe((brand: Option[]) => {
            if (!this.isEditModal) {
                this.relationshipForm.controls.distributorCompanyName.setValue('');
                this.relationshipForm.controls.distributorHvacpId.setValue('');
                this.relationshipForm.controls.distributorSoldTo.setValue('');
                this.companyRelationshipService.initialPage = 0;
            }
            if (Array.isArray(brand) && brand.length) {
                this.companyDetails$.next(null);
                this.brandError$.next(false);
                this.selectedBrand = this.brandsByRelationship.find((brandedRelationship) => brandedRelationship?.id === brand[0].value)?.code || '';
            }
        });

        this.relationshipForm.controls.distributorCompanyName.valueChanges.pipe(
            takeUntil(this.ngOnDestroy$)
        ).subscribe((companyName: string) => {
            if (companyName) {
                this.hvacpIdInputDisabled = true;
                this.soldToInputDisabled = true;
                this.companyQuerySubject$.next(companyName!);
            }
            else {
                this.companyDetails$.next(null);
                this.hvacpIdInputDisabled = false;
                this.soldToInputDisabled = false;
            }
        });

        this.relationshipForm.controls.distributorHvacpId.valueChanges.pipe(
            takeUntil(this.ngOnDestroy$)
        ).subscribe((HvacpId: string) => {
            if (HvacpId) {
                this.companyNameInputDisabled = true;
                this.soldToInputDisabled = true;
                this.companyQuerySubjectHvacpId$.next(HvacpId!);
            }
            else {
                this.companyDetails$.next(null);
                this.companyNameInputDisabled = false;
                this.soldToInputDisabled = false;
            }
        });

        this.relationshipForm.controls.distributorSoldTo.valueChanges.pipe(
            takeUntil(this.ngOnDestroy$)
        ).subscribe((soldTo: string) => {
            if (soldTo) {
                this.companyNameInputDisabled = true;
                this.hvacpIdInputDisabled = true;
                this.companyQuerySubjectSoldTo$.next(soldTo!);
            }
            else {
                this.companyDetails$.next(null);
                this.companyNameInputDisabled = false;
                this.hvacpIdInputDisabled = false;
            }
        });

        this.relationshipForm.controls.cinNumber.valueChanges.pipe(
            takeUntil(this.ngOnDestroy$)
        ).subscribe((cinQuery: string) => {
            const isLengthExceeded = Boolean(cinQuery && cinQuery.length > 10);
            this.CINLengthExceeded$.next(isLengthExceeded);

            const allowedPattern = /^[a-zA-Z0-9!"#$%&'*+\-./\\;?@\]_`]+$/;
            const hasInvalidChars = Boolean(cinQuery && !allowedPattern.test(cinQuery));
            this.CINhasInvalidCharacters$.next(hasInvalidChars);

            if (cinQuery && !isLengthExceeded && !hasInvalidChars) {
                this.cinQuerySubject$.next(cinQuery);
            }
        });

        this.companyDetails$.subscribe((data) => {
            this.isRelationshipExists = Boolean(Number(data?.hvacCompanyId));
            if (!data) {
                this.relationshipForm.controls.claims.setValue('');
            }
        });

        this.companyQuerySubject$.pipe(
            debounceTime(AppConstants.defaultTypeAheadDebounceTime),
            takeUntil(this.ngOnDestroy$)
        ).subscribe((searchTextValue) => {
            this.companyDetailsError$.next(false);
            this.companyLookUpData$.next([]);
            this.brandError$.next(false);
            if (!searchTextValue) {
                return;
            }

            if (!this.isEditModal && this.selectedTab === RelationshipTabOption.BRAND && this.selectedBrand?.length === 0) {
                this.brandError$.next(true);

                return;
            }
            if (!this.isEditModal) {
                this.autoComplete$.next({ loading: true });
                this.companyRelationshipService.getCompaniesByRelationshipQuery(this.selectedTab, AutocompleteInputTypes.CompanyName, {
                    brand: (this.selectedTab === RelationshipTabOption.BRAND && this.selectedBrand.length > 0) ? [this.selectedBrand] : [],
                    company: searchTextValue,
                    brandFamily: this.brandFamily || '',
                    companyType: this.companyConfiguration.companyType || '',
                    companyCategory: this.companyConfiguration.configType || ''
                }, this.companyLookUpData$, false);
            }
        });

        this.companyQuerySubjectHvacpId$.pipe(
            debounceTime(AppConstants.defaultTypeAheadDebounceTime),
            takeUntil(this.ngOnDestroy$)
        ).subscribe((searchTextValue) => {
            this.companyDetailsError$.next(false);
            this.companyLookUpDataHvacpId$.next([]);
            this.brandError$.next(false);
            if (!searchTextValue) {
                return;
            }

            if (!this.isEditModal && this.selectedTab === RelationshipTabOption.BRAND && this.selectedBrand?.length === 0) {
                this.brandError$.next(true);

                return;
            }
            if (!this.isEditModal) {
                this.autoCompleteHvacId$.next({ loading: true });
                this.companyRelationshipService.getCompaniesByRelationshipQuery(this.selectedTab, AutocompleteInputTypes.HvacpId, {
                    brand: (this.selectedTab === RelationshipTabOption.BRAND && this.selectedBrand.length > 0) ? [this.selectedBrand] : [],
                    company: searchTextValue,
                    brandFamily: this.brandFamily || '',
                    companyType: this.companyConfiguration.companyType || '',
                    companyCategory: this.companyConfiguration.configType || ''
                }, this.companyLookUpDataHvacpId$, false);
            }
        });

        this.companyQuerySubjectSoldTo$.pipe(
            debounceTime(AppConstants.defaultTypeAheadDebounceTime),
            takeUntil(this.ngOnDestroy$)
        ).subscribe((searchTextValue) => {
            this.companyDetailsError$.next(false);
            this.companyLookUpDataSoldTo$.next([]);
            this.brandError$.next(false);
            if (!searchTextValue) {
                return;
            }

            if (!this.isEditModal && this.selectedTab === RelationshipTabOption.BRAND && this.selectedBrand?.length === 0) {
                this.brandError$.next(true);

                return;
            }
            if (!this.isEditModal) {
                this.autoCompleteSoldTo$.next({ loading: true });
                this.companyRelationshipService.getCompaniesByRelationshipQuery(this.selectedTab, AutocompleteInputTypes.SoldTo, {
                    brand: (this.selectedTab === RelationshipTabOption.BRAND && this.selectedBrand.length > 0) ? [this.selectedBrand] : [],
                    company: searchTextValue,
                    brandFamily: this.brandFamily || '',
                    companyType: this.companyConfiguration.companyType || '',
                    companyCategory: this.companyConfiguration.configType || ''
                }, this.companyLookUpDataSoldTo$, false);
            }
        });

        this.cinQuerySubject$.pipe(
            debounceTime(AppConstants.defaultTypeAheadDebounceTime),
            switchMap((cinQuery) => {
                this.invalidCIN$.next(false);
                if (!cinQuery) {
                    return EMPTY;
                }
                if (!this.companyDetails$.value) {
                    this.companyDetailsError$.next(true);

                    return of(false);
                }

                if (!this.isEditModal) {
                    return this.companyQuery.validateCIN({
                        CIN: cinQuery,
                        distributorCompanyId: Number(this.companyDetails$.value.hvacCompanyId),
                        relationshipTypeId: this.selectedTab === RelationshipTabOption.PRICING ? RelationshipTypeId.PRICING : RelationshipTypeId.WARRANTY
                    }).pipe(
                        tap((response) => {
                            this.isRelationshipExists = true;
                            this.invalidCIN$.next(response.status === API_RESPONSE.SUCCESS);
                        }),
                        catchError((err) => {
                            this.isRelationshipExists = false;
                            this.invalidCIN$.next(err.status === API_RESPONSE.CONFLICT);

                            return EMPTY;
                        })
                    );
                }

                return of(false);
            }),
            takeUntil(this.ngOnDestroy$)
        ).subscribe();
    }

    saveChanges() {
        Object.keys(this.relationshipForm.controls).forEach((key) => {
            this.relationshipForm.get(key)?.markAsDirty();
        });
        this.isFormValid = this.isFormValidByTab(this.selectedTab);
        const parentCompany = this.companyDetails$.value;

        if (this.isFormValid) {
            const dealerDistributor: DealerDistributor = {
                comment: this.relationshipForm.controls.comments.value,
                companyRelationShipId: this.isEditModal ? Number(this.selectedCompany.dealerDistributor.companyRelationShipId) : 0,
                createdDate: new Date().toISOString(),
                status: ACTIVATED_STAT,
                distributorCompanyId: Number(parentCompany?.hvacCompanyId) || 0,
                distributorCompanyName: parentCompany?.companyName || '',
                distributorAddress: parentCompany?.address1 || '',
                validToDate: '',
                isSameHierarchy: this.isEditModal ? 'true' : ''
            };
            if (this.selectedTab === RelationshipTabOption.BRAND) {
                const brandedRelationship: BrandedRelationships = {
                    dealerDistributor: dealerDistributor,
                    brandId: this.relationshipForm.controls.brand.value[0].value,
                    brandName: this.relationshipForm.controls.brand.value[0].name,
                    tierLevel: this.relationshipForm.controls.tierLevel.value[0]?.name || '',
                    tierLevelId: Number(this.relationshipForm.controls.tierLevel.value[0]?.value) || 0
                };
                this.tableData.push(brandedRelationship);
            }
            else {
                const pricingWarrantyRelationships: PricingWarrantyRelationships = {
                    dealerDistributor: dealerDistributor,
                    cin: this.relationshipForm.controls.cinNumber.value,
                    claims: this.relationshipForm.controls.claims.value[0]?.value || '',
                    hvp: '',
                    relationshipId: (this.selectedTab === RelationshipTabOption.PRICING) ? RelationshipTypeId.PRICING : RelationshipTypeId.WARRANTY,
                    relationshipType: (this.selectedTab === RelationshipTabOption.PRICING) ? RelationshipTypeCode.PRICING : RelationshipTypeCode.WARRANTY,
                    relationTypeCode: null,
                    soldTo: Number(parentCompany?.soldTo) || 0
                };

                if ((this.selectedTab === RelationshipTabOption.PRICING && this.isDuplicatePricingWarrantyEntry(pricingWarrantyRelationships)) || (this.selectedTab === RelationshipTabOption.WARRANTY && this.isDuplicatePricingWarrantyEntry(pricingWarrantyRelationships))) {
                    this.resetForm();
                    this.scrollToToast();
                    this.toastService.add({
                        content: this.translate.instant('ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.PRICING_RELATIONSHIP_VALIDATION_ERROR', {
                            selectedBrand: dealerDistributor.distributorCompanyName,
                            cinNumber: pricingWarrantyRelationships.cin
                        }),
                        id: 'parentCompanyId',
                        theme: 'error',
                        closeable: true,
                        autoClose: true,
                        outletName: this.validationToastErrorId
                    });
                }
                else {
                    this.tableData.push(pricingWarrantyRelationships);
                }
            }
            this.resetForm();
        }
    }

    isDuplicatePricingWarrantyEntry(newEntry: PricingBrandWarrantyRelationship): boolean {
        return this.tableData.some((existing) => existing.dealerDistributor.distributorCompanyId === newEntry.dealerDistributor.distributorCompanyId &&
            existing.cin === newEntry.cin && existing.relationshipType === newEntry.relationshipType);
    }

    updateRelationship() {
        this.saveChanges();
        this.addRelationships();
    }

    getNewBrandsList() {
        this.accountAdminExtendedService.getBrands(false).subscribe((data) => {
            this.brandList = data.map((option:AccountAdminBrandsItemsEntity) => ({
                name: option.name,
                value: option.code
            }));

            this.brandList = this.brandsByRelationship?.filter((relationship) => relationship && this.brandList?.some((brand) => brand.value === relationship.code)).map((brand) => ({
                name: brand?.name,
                value: brand?.id
            }) as Option);
            const uniqueBrands = Array.from(new Map(this.brandList?.map((brand) => [brand.value, brand])).values());
            this.brandList = uniqueBrands;
            this.brandList.sort((valueA, valueB) => valueA.name.toLowerCase().localeCompare(valueB.name.toLowerCase()));
            this.brandList.unshift({
                name: this.translate.instant('ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.SELECT_BRANDS'),
                value: ''
            });
        });
    }

    addRelationships() {
        const priceWarrantyRelationships = this.tableData.filter((item) => (item.relationshipId === RelationshipTypeId.PRICING || item.relationshipId === RelationshipTypeId.WARRANTY));
        const brandedRelationships = this.tableData.filter((item) => !(Object.prototype.hasOwnProperty.call(item, RelationTypeCodeField.RelationTypeCode)));
        this.submitChanges.emit({
            brandedRelationships: brandedRelationships,
            pricingWarrantyRelationships: priceWarrantyRelationships,
            edit: this.isEditModal
        });
        this.tableData = [];
        this.showRelationshipList = false;
        this.isEditModal = false;
        this.companyRelationshipService.claimTypeOptions$.next([{
            name: '',
            value: ''
        }]);
    }

    handleTabClick(tabSelection: ManageRelationshipProfiles) {
        this.tabAfterModalClose = tabSelection;
        if (this.relationshipForm.dirty && this.selectedTab !== tabSelection) {
            this.unsavedChangesModal = true;
            this.warningMessage = this.translate.instant('ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.UNSAVED_CHANGES_WARNING_MODAL.WARNING_INFO', { selectedTab: this.selectedTab });
        }
        else if (this.relationshipForm.dirty && this.selectedTab === tabSelection) {
            this.unsavedChangesModal = false;
        }
        else {
            this.resetForm();
            this.selectedTab = tabSelection;
            this.formConfig$.next(this.config[tabSelection]);
        }
    }

    brandedRelationValidation(option: Option) {
        const parentCompanyId = option?.value?.split('-')[0].trim();
        const childCompanyId = (this.hvacCompanyId) ? this.hvacCompanyId : '';
        const brandId = this.relationshipForm.controls.brand.value[0]?.value;
        const brandName = this.relationshipForm.controls.brand.value[0]?.name;

        if (!this.isCreate) {
            this.accountAdminExtendedService.brandRelationshipValidation(parentCompanyId, childCompanyId, brandId).subscribe((response) => {
                if (response.statusCode !== 'OK') {
                    this.scrollToToast();
                    this.isRelationshipExists = false;
                    this.resetForm();
                    this.toastService.add({
                        content: this.translate.instant('ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.RELATIONSHIP_VALIDATION_ERROR', {
                            selectedBrand: brandName,
                            selectedCompany: option.name
                        }),
                        id: childCompanyId,
                        theme: 'error',
                        closeable: true,
                        autoClose: true,
                        outletName: this.validationToastErrorId
                    });
                }
            }, (error) => {
                if (error.status === 409) {
                    this.scrollToToast();
                    this.isRelationshipExists = false;
                    this.resetForm();
                    this.toastService.add({
                        content: this.translate.instant('ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.RELATIONSHIP_VALIDATION_ERROR', {
                            selectedBrand: brandName,
                            selectedCompany: option.name
                        }),
                        id: childCompanyId,
                        theme: 'error',
                        closeable: true,
                        autoClose: true,
                        outletName: this.validationToastErrorId
                    });
                }
            });
        }

        const isDuplicateBrand = this.tableData.some(
            (item) => item.brandId === brandId &&
                  item.dealerDistributor.distributorCompanyId === Number(parentCompanyId)
        );

        if (isDuplicateBrand) {
            this.scrollToToast();
            this.resetForm();
            this.toastService.add({
                content: this.translate.instant('ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.RELATIONSHIP_VALIDATION_ERROR', {
                    selectedBrand: brandName,
                    selectedCompany: parentCompanyId
                }),
                id: parentCompanyId,
                theme: 'error',
                closeable: true,
                autoClose: true,
                outletName: this.validationToastErrorId
            });
        }
    }

    onCompanyLookUp(option: Option) {
        if (this.selectedTab === RelationshipTabOption.BRAND) {
            this.brandedRelationValidation(option);
        }
        const companyLookup: CompanyDetailsResponse | null = this.companyRelationshipService.companyDetails.find((company) => company.hvacCompanyId === option.value.split(' - ')[0]) || null;
        this.companyDetails$.next(companyLookup);
        this.companyRelationshipService.getClaimTypeOptions(companyLookup?.warranty);
        this.companyRelationshipService.claimTypeOptions$.pipe(
            takeUntil(this.ngOnDestroy$)
        ).subscribe((claimOptions) => {
            if (claimOptions.length <= 1) {
                return;
            }
            const defaultClaim = claimOptions.find((clmopt) => clmopt.value === companyLookup?.warranty);
            this.relationshipForm.controls.claims.setValue(defaultClaim ? [defaultClaim] : '');
        });
    }

    companyLookupWithPagination() {
        this.autoComplete$.next({ loading: true });
        this.companyRelationshipService.getCompaniesByRelationshipQuery(this.selectedTab, AutocompleteInputTypes.CompanyName, {
            brand: (this.selectedTab === RelationshipTabOption.BRAND && this.selectedBrand.length > 0) ? [this.selectedBrand] : [],
            company: this.companyQuerySubject$.value,
            companyType: this.companyConfiguration.companyType || ''
        }, this.companyLookUpData$, true);
    }

    companyHvacpIdLookupWithPagination() {
        this.autoCompleteHvacId$.next({ loading: true });
        this.companyRelationshipService.getCompaniesByRelationshipQuery(this.selectedTab, AutocompleteInputTypes.HvacpId, {
            brand: (this.selectedTab === RelationshipTabOption.BRAND && this.selectedBrand.length > 0) ? [this.selectedBrand] : [],
            company: this.companyQuerySubject$.value,
            companyType: this.companyConfiguration.companyType || ''
        }, this.companyLookUpDataHvacpId$, true);
    }

    companySoldToLookupWithPagination() {
        this.autoCompleteSoldTo$.next({ loading: true });
        this.companyRelationshipService.getCompaniesByRelationshipQuery(this.selectedTab, AutocompleteInputTypes.SoldTo, {
            brand: (this.selectedTab === RelationshipTabOption.BRAND && this.selectedBrand.length > 0) ? [this.selectedBrand] : [],
            company: this.companyQuerySubject$.value,
            companyType: this.companyConfiguration.companyType || ''
        }, this.companyLookUpDataSoldTo$, true);
    }

    handleCloseModal() {
        if (this.tableData.length >= 1) {
            this.unsavedRelationshipsModal = true;
        }
        else {
            this.resetRelationships();
        }
    }

    unsavedChangesModalClose() {
        this.unsavedChangesModal = false;
    }

    unsavedRelationshipsModalClose() {
        this.unsavedRelationshipsModal = false;
    }

    removeUnsavedRelationships() {
        this.unsavedRelationshipsModal = false;
        this.resetRelationships();
    }

    resetRelationships() {
        this.adminService.isModalVisible = false;
        this.tableData = [];
        this.showRelationshipList = false;
        this.isEditModal = false;
        this.resetForm();
    }

    removeUnsavedChanges() {
        this.unsavedChangesModal = false;
        this.resetForm();
        this.selectedTab = this.tabAfterModalClose;
        this.formConfig$.next(this.config[this.tabAfterModalClose]);
    }

    removeRelationship(distributor: PricingBrandWarrantyRelationship) {
        this.tableData = this.tableData.filter((item) => {
            if (item.relationshipType === distributor.relationshipType) {
                return !(
                    item.dealerDistributor.distributorCompanyId === distributor.dealerDistributor.distributorCompanyId && item.brandName === distributor.brandName && item.cin === distributor.cin
                );
            }

            return true;
        });
        this.showRelationshipList = this.tableData.length > 0;
    }

    getErrorMessage(): Observable<string> {
        return combineLatest([
            this.invalidCIN$,
            this.CINLengthExceeded$,
            this.CINhasInvalidCharacters$,
            this.relationshipForm.controls.cinNumber.valueChanges.pipe(
                startWith(this.relationshipForm.controls.cinNumber.value),
                map((value) => !value)
            ),
            of(this.relationshipForm.controls.cinNumber.dirty)
        ]).pipe(
            map(([isInvalid, isLengthExceeded, hasInvalidChars, isEmpty, isDirty]) => {
                if (isDirty && isEmpty) {
                    return this.translate.instant('ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.CIN_REQUIRED');
                }
                else if (isDirty && hasInvalidChars) {
                    return this.translate.instant('ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.CIN_INVALID_CHARS');
                }
                else if (isDirty && isLengthExceeded) {
                    return this.translate.instant('ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.CIN_LENGTH');
                }
                else if (isDirty && isInvalid) {
                    return this.translate.instant('ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.CIN_INVALID');
                }

                return '';
            })
        );
    }


    public scrollToToast(): void {
        const toastEl = document.getElementById('toastMessage');

        if (toastEl) {
            toastEl.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
        else {
            console.warn('Toast element not found!');
        }
    }


    private resetForm() {
        this.relationshipForm.reset({
            brand: '',
            tierLevel: '',
            claims: ''
        });
        this.companyRelationshipService.companyDetails = [];
        this.isRelationshipExists = false;
        this.companyDetails$.next(null);
        this.selectedBrand = '';
        this.brandError$.next(false);
        this.companyDetailsError$.next(false);
    }

    private setClaimsEntitlementField(code?:string) {
        if (code === ClaimOption.ENTITLEMENT) {
            this.relationshipForm.controls.claims.setValue(this.translate.instant('ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.ENTITLEMENT'));
        }
        else if (code === ClaimOption.ENTITLEMENT_AND_CLAIMS) {
            this.relationshipForm.controls.claims.setValue(this.translate.instant('ACCOUNT_ADMIN.DISTRIBUTOR_MODAL.ENTITLEMENT_CLAIMS'));
        }
    }

    private isFormValidByTab(tab: ManageRelationshipProfiles): boolean {
        if (this.isEditModal) {
            return this.isRelationshipExists && this.relationshipForm.controls.comments.valid;
        }

        switch (tab) {
            case RelationshipTabOption.BRAND:
                return this.relationshipForm.controls.brand.valid
                    && this.isRelationshipExists;
            case RelationshipTabOption.PRICING:
                return this.isRelationshipExists
                    && this.relationshipForm.controls.cinNumber.valid;
            case RelationshipTabOption.WARRANTY:
                return this.isRelationshipExists
                    && this.relationshipForm.controls.cinNumber.valid
                    && this.relationshipForm.controls.claims.valid
                    && Boolean(this.relationshipForm.controls.claims.value[0]?.value);
            default:
                return false;
        }
    }

    private updateTierLevelVisibility(): void {
        const services = this.isCreate ? this.companyCreateService.companyCreateForm.controls.services?.value : this.companyServices;
        this.showTierLevel = Array.isArray(services) && services.some((service: Option | CompanyServices) => service?.name?.toLowerCase().includes('residential'));
        this.config.branded.tierLevel = this.showTierLevel;
        if (!this.showTierLevel) {
            this.relationshipForm.controls.tierLevel.setValue('');
        }
        this.formConfig$.next(this.config[this.selectedTab]);
    }
}
